// Normalize Carousel Heights - pass in Bootstrap Carousel, then get their slides.
$.fn.carouselHeights = function () {
    var $items = $(this).find('.carousel-item'), //grab all slides of the current carousel
        $heights = [],
        $tallest;

    var normalizeHeights = function () {
        $items.each(function () {
            //using outer height to make sure any special padding is caught too
            $heights.push($(this).outerHeight());
        });
        $tallest = Math.max.apply(null, $heights);
        $items.each(function () {
            $(this).css('min-height', $tallest + 'px');
        });
    };

    normalizeHeights();

    $(window).on('resize orientationchange', function () {
        $tallest = 0;
        $heights.length = 0;

        $items.each(function () {
            $(this).css('min-height', '0');
        });
        normalizeHeights();
    });
};

//get the images of the carousel to set the thumbnails if that indicator type is picked
$.fn.carouselThumbnails = function () {
    var $items = $(this).find('.carousel-item'), //grab all slides of the current carousel
        $indicators = $(this).find('.pd-carousel-indicators li'),
        $thumbnails = [],
        $focalPoints = [];

    $thumbnails = $items
        .find('img')
        .map(function () {
            $focalPoints.push($(this).attr('style').toString());
            return $(this).attr('src');
        })
        .get();

    $indicators.each(function (index) {
        var imageDiv =
            '<div class="thumbnail-wrapper"><img style="' +
            $focalPoints[index] +
            '" src="' +
            $thumbnails[index] +
            '" /></div>';
        $(imageDiv).appendTo($(this));
    });
};

jQuery(function ($) {
    $(window).on('load', function () {
        $('.experience-component .carousel').each(function () {
            $(this).carouselHeights();
        });
        $('.experience-component .carousel.thumbnail-indicators').each(
            function () {
                $(this).carouselThumbnails();
            }
        );
    });
});
